<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-actions class="pb-0">
                        <v-spacer></v-spacer>
                        <v-btn class="text-xs-right" color="success" @click=""
                            >Submit</v-btn
                        >
                    </v-card-actions>
                    <v-layout column>
                        <v-card-actions class="pt-0">
                            <v-layout row>
                                <v-flex xs4 class="pt-0">
                                    <v-card-text class="pl-2"
                                        >Search By Name</v-card-text
                                    >
                                    <vue-select2
                                        style="font-size: 27px"
                                        class="mb-3 ml-2 select2-custom"
                                        :options="accounts"
                                        label="displayName"
                                        v-model="account"
                                        :filterable="false"
                                        @search="onSearchAccounts"
                                        @input="onSelected"
                                    ></vue-select2>
                                </v-flex>
                                <v-flex xs6 class="pt-0">
                                    <v-card-text class="pl-0"
                                        >Search By Phone Number</v-card-text
                                    >
                                    <v-layout row>
                                        <v-text-field
                                            solo
                                            label="Phone Number"
                                            v-model="phoneSearch"
                                            mask="###-###-####"
                                            @input="searchByPhone"
                                        ></v-text-field>
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            @click="searchDialog = true"
                                            >Search Accounts</v-btn
                                        >
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="newAccountDialog = true"
                                            >New Account</v-btn
                                        >
                                        <v-btn
                                            v-if="account.nonUTA"
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="editAccount"
                                            >Edit Account</v-btn
                                        >
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                        <div v-if="account.accountID">
                            <v-flex xs12 class="pt-0">
                                <v-layout row>
                                    <v-layout column class="ml-4">
                                        <v-card-title
                                            primary-title
                                            class="pt-3 py-0"
                                        >
                                            <div>
                                                <v-layout
                                                    row
                                                    v-if="account.nonUTA"
                                                    align-center
                                                    class="pl-2 py-2"
                                                >
                                                    <h3 class="headline my-0">
                                                        Account ID:
                                                        {{ account.accountID }}
                                                    </h3>
                                                    <div
                                                        class="font-weight-medium ml-2 text-info"
                                                    >
                                                        Non UTA
                                                    </div>
                                                </v-layout>
                                                <h3
                                                    class="headline my-0"
                                                    v-if="!account.nonUTA"
                                                >
                                                    Account ID:
                                                    {{ account.accountID }}
                                                </h3>
                                            </div>
                                        </v-card-title>
                                        <v-card-text class="mb-2 py-0">
                                            <h4
                                                class="card-title font-weight-medium"
                                            >
                                                {{ account.name }}
                                            </h4>
                                            <p>
                                                {{ account.hname }}
                                            </p>
                                            <p>
                                                {{ account.address1 }}
                                            </p>
                                            <br />
                                            <div class="ml-2 mt-2">
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home:
                                                    </div>
                                                    <div>
                                                        {{ account.homePhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell:
                                                    </div>
                                                    <div>
                                                        {{ account.cellPhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-3">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Email:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.emailAddress
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </v-card-text>
                                    </v-layout>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="mb-2 mt-3" v-if="account.accountID">
                    <v-layout row>
                        <v-card-title class="headline pr-0 pb-2 pt-2 pl-3 ml-3"
                            >Lapidus Settings</v-card-title
                        >
                        <v-btn
                            class="ml-3 my-3"
                            @click="openLapidusDialog"
                            color="success"
                            style="height: 28px;"
                            small
                            >Day Camp Charge</v-btn
                        >
                    </v-layout>
                    <v-divider></v-divider>
                    <div v-if="lapidusTransaction" class="ml-4 mt-2 pt-3 pl-2">
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Entered On:
                            </div>
                            <div>
                                {{ lapidusTransaction.date | time }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Bungalow:
                            </div>
                            <div>
                                {{ lapidusTransaction.bungalow }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium width-200">
                                Rooms:
                            </div>
                            <div>
                                {{ lapidusTransaction.quantity }}
                            </div>
                        </v-layout>
                        <v-layout
                            row
                            class="mb-2"
                            v-if="lapidusTransaction.note"
                        >
                            <div class="font-weight-medium width-200">
                                Note:
                            </div>
                            <div>
                                {{ lapidusTransaction.note }}
                            </div>
                        </v-layout>
                        <v-layout row class="pb-3">
                            <div class="font-weight-medium width-200">
                                Total:
                            </div>
                            <div>
                                {{ lapidusTransaction.total | currency }}
                            </div>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="searchDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    :title="searchDialogTitle"
                    navigationPath="Account View"
                    navigationField="accountID"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
        <v-dialog v-model="lapidus.lapidusDialog" max-width="400" persistent>
            <v-card class="pa-3">
                <v-card-title class="headline pa-0 mb-2"
                    >Day Camp Charge</v-card-title
                >
                <v-text-field
                    v-model="lapidus.bungalow"
                    label="Bungalow"
                    ref="lapidusBungalow"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    v-model="lapidus.quantity"
                    type="number"
                    label="Rooms"
                    ref="lapidusQuantity"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    v-model="lapidus.note"
                    label="Note"
                ></v-text-field>
                <v-text-field
                    v-model="lapidus.charge"
                    type="number"
                    label="Charge"
                    ref="lapidusCharge"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-layout row justify-space-between>
                    <div class="font-weight-medium">Total:</div>
                    <div class="font-weight-medium">
                        $ {{ (lapidus.quantity || 0) * (lapidus.charge || 0) }}
                    </div>
                </v-layout>
                <v-card-actions class="mx-0 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        class="mr-1"
                        @click="lapidus.lapidusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveLapidusCharge()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy } from "../../utils/helpers.js";
import odata from "odata-client";
import ky from "../../utils/ky.js";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
    components: {
        "vue-select2": vueSelect2,
    },
    data: () => ({
        phoneSearch: "",
        accounts: [],

        account: {},
        country: "",
        bungalow: "",
        note: "",

        uploading: false,

        confirmDialog: false,
        processing: false,

        searchDialogTitle: "Accounts",
        searchDialog: false,

        lapidusTransaction: "",

        lapidus: {
            lapidusDialog: false,
            bungalow: "",
            note: "",
            quantity: 1,
            charge: 400,
            id: 0,
        },

        rules: {
            required: (value) => !!value || "Required",
        },

        regID: "",

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    async created() {
        await this.loadRegID();
        await this.loadDefaultCharge();
    },
    methods: {
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        onSearchAccounts(search, loading) {
            loading(true);

            this.searchAccounts(loading, search);
        },
        async searchAccounts(loading, searchTerm) {
            const request = odata({
                service: getDomain() + "/odata/",
                resources: "accounts",
            }).top(30);

            request._headers[
                "Authorization"
            ] = this.$store.state.authentication.token;

            if (searchTerm) {
                request.filter(`startswith(lastname, '${searchTerm}')`);
            }

            const response = await request.get();

            this.accounts = JSON.parse(response.body).value.map((account) => {
                account.displayName =
                    account.lastName + " " + account.firstName;

                return account;
            });

            loading(false);
        },
        onSearchAccountsRowClicked(account) {
            this.searchDialog = false;

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        async searchByPhone(value) {
            if (value.length < 10) return;

            const account = await this.$http.get(
                `api/lapidusDayCamp/getAccountByPhoneNumber?phoneNumber=${value}`
            );

            if (!account) {
                this.$notify({
                    text: "Account Does Not Exist",
                    group: "notification",
                    type: "warning",
                });

                return;
            }

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        async onSelected(account) {
            if (!account) {
                return this.clearSelection();
            }

            this.accounts = [];

            this.onAccountSelected();
        },
        async onAccountSelected() {
            this.loadTransaction();
        },
        async loadTransaction() {
            this.lapidusTransaction = await this.$http.get(
                "api/lapidusDayCamp/getTransaction?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID
            );
        },
        async loadDefaultCharge() {
            this.lapidus.charge = await this.$http.get(
                "api/lapidusTransactions/getDefaultCharge"
            );
        },
        openLapidusDialog() {
            if (this.lapidusTransaction) {
                this.lapidus.bungalow = this.lapidusTransaction.bungalow;
                this.lapidus.quantity = this.lapidusTransaction.quantity;
                this.lapidus.note = this.lapidusTransaction.note;
                this.lapidus.charge = this.lapidusTransaction.charge;
                this.lapidus.id = this.lapidusTransaction.id;
            }

            this.lapidus.lapidusDialog = true;
        },
        async saveLapidusCharge() {
            if (
                !this.$refs.lapidusBungalow.validate(true) ||
                !this.$refs.lapidusQuantity.validate(true) ||
                !this.$refs.lapidusCharge.validate(true)
            )
                return;

            try {
                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");
                const year = moment().format("YYYY");

                await this.$http.post(
                    "api/lapidusDayCamp/saveLapidusTransaction",
                    {
                        accountID: this.account.accountID,
                        type: "Charge",
                        year: year,
                        date: today,
                        byUser: this.$store.state.authentication.user,
                        bungalow: this.lapidus.bungalow,
                        note: this.lapidus.note,
                        quantity: this.lapidus.quantity,
                        charge: this.lapidus.charge,
                        id: this.lapidus.id,
                        total:
                            (this.lapidus.quantity || 0) *
                            (this.lapidus.charge || 0),
                    }
                );

                this.processing = false;
                this.lapidus.lapidusDialog = false;

                this.loadTransaction();
            } catch (e) {
                this.processing = false;
            }
        },
        clearSelection() {
            this.phoneSearch = "";
            this.students = [];
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.v-btn__content {
    color: unset;
}
.bungalow-required {
    border-bottom: 2px red solid;
}
</style>
